import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useSelector } from "react-redux";
import { selectors } from "redux-store";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: "fixed",
      top: "auto",
      bottom: 0,
      background: "#FFA900",
      alignItems: "center",
    },
    icon: {
      marginRight: "20px",
    },
  }),
);

const useNetworkToolbar = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const online = useSelector(selectors.getNetworkState);
  const [t] = useTypedTranslations();

  return {
    styles,
    classes,
    atomicStyles,
    online,
    t,
  };
};

export { useNetworkToolbar as default };
